export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_REQUEST_TUTOR = 'AUTH_REQUEST_TUTOR'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_ERROR = 'AUTH_ERROR'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const LOGIN_AS = 'LOGIN_AS'
export const REVERT = 'REVERT'


// WEBPACK FOOTER //
// ./src/store/actions/auth.js